import { getNegStatusOption } from '../../../lib/negotiationNegStatus'
import classesCell from './BodyCell.module.css'
import statusClasses from './StatusCell.module.css'
import classes from './NegStatusCell.module.css'

export default function NegStatusCell({ status }) {
    const option = getNegStatusOption(status)

    if (!option) {
        return null
    }

    const statusClass = classes[option.value] ?? ''

    return (
        <div className={statusClasses.status_cell_wrapper}>
            <div
                className={`${statusClasses.status_cell} ${classesCell.status_cell} ${classes.cell} ${statusClass}`}
            >
                {option.label}
            </div>
        </div>
    )
}
